var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{staticClass:"tag",attrs:{"type":_vm.tagType,"title":_vm.followers.toLocaleString() + " followers"}},[_vm._v(_vm._s(_vm.tagText))])}
var staticRenderFns = []

export { render, staticRenderFns }